<template>
  <v-app>
    <v-main class="app-content">
      <title-page
        :blue="true"
        title="باربری های همکار"
        :sheetStyle="['transparent', '-mt-1']"
        class="pb-15"
        back-link="/Panel/LoadManagement"
        :navbar-optional-classes="['position-fixed-desktop']"
      >
        <div v-if="drafts && drafts.length > 0" class="mobile-container">
          <v-row class="mx-0 pt-md-5 px-md-10">
            <v-col
              class="pb-0 px-4 mt-3 pt-05 pt-md-4"
              cols="12"
              v-for="(draft, index) of drafts"
              :key="draft.objectId"
              v-intersect="index + 1 == drafts.length && infiniteScrolling"
            >
              <draft-card
                @get-drafts="getDrafts(true)"
                :draft="draft"
                :just-trash="true"
                deleteCloud="remove_hamkar_barbari_by_company"
                :deleteParameter="{
                  hamkarId: draft.objectId,
                }"
              >
              </draft-card>
            </v-col>
          </v-row>
        </div>

        <!-- if empty -->
        <div v-else class="h-half-screen d-flex justify-center align-center">
          <div>
            <loading v-if="loading"></loading>
            <div
              v-else
              class="text-center font-xsmall grey--text text-darken-2"
            >
              <svg-icon name="notice"></svg-icon>
              <div class="mt-8">شما باربری همکار ندارید</div>
              <div>
                دکمه
                <span class="logistic--text">افزودن باربری همکار</span>
                را بزنید و آن را ذخیره کنید.
              </div>
            </div>
          </div>
        </div>

        <template #navbar>
          <v-col class="pa-0">
            <v-btn
              to="/Panel/SelectedCompanies/new"
              class="logistic-color white--text w-100 py-6"
              elevation="0"
            >
              <v-icon>mdi-plus</v-icon>
              افزودن باربری همکار
            </v-btn>
          </v-col>
        </template>
      </title-page>
    </v-main>
  </v-app>
</template>

<script>
import TitlePage from "../components/Layouts/TitlePage.vue";
import DraftCard from "../components/DraftCard.vue";
import configs from "../mixins/configs";

export default {
  components: { TitlePage, DraftCard },
  mixins: [configs],
  name: "SelectedCompanies",
  data() {
    return {
      loading: true,
      all_drafts: [],
      search_status: false,
      search: "",
      drafts: [],
      skip: 0,
    };
  },
  watch: {
    search(val) {
      let filtered = this.all_drafts.filter((d) =>
        d.short_name.startsWith(val)
      );
      if (val != "") {
        this.drafts = filtered;
      } else {
        this.drafts = this.all_drafts;
      }
    },
  },
  methods: {
    async getDrafts(reset = false) {
      this.loading = true;
      this.drafts = this.drafts.length ? this.drafts : [];

      if (reset) {
        this.skip = 0;
        this.drafts = [];
      }

      let res = await this.$parseSDK.Cloud.run(
        "get_hamkar_barbaries_by_company",
        {
          skip_number: this.skip,
        }
      ).catch((err) => {
        this.loading = false;
        if (this.$utils.handleErrorIfKnown(err.message)) return;
      });

      if (res) {
        const drafts = JSON.parse(JSON.stringify(res));
        let reformResponse = [];

        drafts.map((item) => {
          reformResponse.push({
            full_name: item.barbari.full_name,
            objectId: item.objectId,
            short_name: item.name,
            phone: item.barbari.username,
          });
        });

        this.all_drafts = this.all_drafts.concat(reformResponse);
        this.drafts = this.drafts.concat(reformResponse);
        this.loading = false;
      }
    },
    resetSearch() {
      this.search_status = false;
      this.search = "";
    },
    openSearchBox() {
      this.search_status = true;
      setTimeout(() => this.$refs.search_field.focus());
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      if (
        isIntersecting &&
        this.drafts.length % 10 === 0 &&
        this.drafts.length > this.skip
      ) {
        this.skip += 10;
        this.getDrafts();
      }
    },
  },
  mounted() {
    this.getDrafts();
  },
};
</script>

<style lang="scss" scoped>
.-mt-1 {
  margin-top: -10px;
}
.h-half-screen {
  height: calc(100vh - 250px);
}

@media screen and (min-width: 980px) {
  .body-color {
    background-color: white !important;
  }
}

.address-search-field {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  justify-content: center;
  display: flex;
  background-color: white;
}
.address-search-field input {
  padding: 0.8rem 1rem !important;
  width: 100%;
  max-width: 780px;
}
.address-search-field .mdi-close {
  position: relative;
  top: 0;
  left: calc(1rem - 4px);
  z-index: 2;
  cursor: pointer;
  padding: 2px;
  filter: grayscale(100%);
}
</style>
